<template>
        <v-layout wrap>
            <v-flex xs12 pa-0>

                <v-card style="border-radius: 10px">

                    <v-sheet height="249">
                        <vue-content-loading :width="800" :height="50" :speed="2" :primary="primaryColor" :secondary="secondaryColor">

                            <circle cx="30" cy="30" r="20" />

                            <rect x="58" y="20" rx="5" ry="5" width="90" height="15" />

                            <rect x="155" y="20" rx="8" ry="8" width="40" height="15" />
                            <rect x="200" y="20" rx="8" ry="8" width="60" height="15" />
                            <rect x="265" y="20" rx="8" ry="8" width="40" height="15" />

                        </vue-content-loading>

                        <v-divider class="mt-3"></v-divider>

                        <v-sheet height="70" class="pa-3 mt-3">

                            <vue-content-loading :width="800" :height="60" :speed="2" :primary="primaryColor" :secondary="secondaryColor">

                                <rect x="10" y="0" rx="3" ry="3" width="90" height="8" />
                                <rect x="110" y="0" rx="3" ry="3" width="20" height="8" />

                                <rect x="10" y="15" rx="3" ry="3" width="50" height="8" />
                                <rect x="70" y="15" rx="3" ry="3" width="90" height="8" />

                                <rect x="10" y="30" rx="3" ry="3" width="90" height="8" />
                                <rect x="110" y="30" rx="3" ry="3" width="20" height="8" />

                                <rect x="10" y="45" rx="3" ry="3" width="50" height="8" />
                                <rect x="70" y="45" rx="3" ry="3" width="90" height="8" />




                                <rect x="400" y="0" rx="3" ry="3" width="90" height="8" />
                                <rect x="460" y="0" rx="3" ry="3" width="20" height="8" />

                                <rect x="400" y="15" rx="3" ry="3" width="50" height="8" />
                                <rect x="460" y="15" rx="3" ry="3" width="90" height="8" />

                                <rect x="400" y="30" rx="3" ry="3" width="90" height="8" />
                                <rect x="110" y="30" rx="3" ry="3" width="20" height="8" />

                                <rect x="400" y="45" rx="3" ry="3" width="50" height="8" />
                                <rect x="460" y="45" rx="3" ry="3" width="90" height="8" />




                            </vue-content-loading>

                        </v-sheet>

                    </v-sheet>

                </v-card>

            </v-flex>
        </v-layout>

</template>

<script>
    import VueContentLoading, {VclFacebook, VclInstagram, VclCode} from 'vue-content-loading';
    import {mapState} from 'vuex'

    export default{
        components:{
            VueContentLoading,
        },
      computed:{
          ...mapState(['isDark']),
          primaryColor(){
            const vm = this
            return vm.isDark ? '#1f1f23' : '#d2d6dd'
          },
          secondaryColor(){
            const vm = this
            return vm.isDark ? '#23232b' : '#eae9e9'
          }
      }
    }
</script>
